<app-page-header [title]="'Sample Firmware Revisions'" [subtitle]="'Manage Sample Firmware Revisions for Sample Studio'"></app-page-header>
<div class="mb-6">
    <div class="flex justify-between mb-2">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-search"></p-inputicon>
                <input pInputText id="sample_firmware_revision_search" [(ngModel)]="this.search" (input)="onSearchInputChange()"
                       autocomplete="off"/>
            </p-iconfield>
            <label for="sample_firmware_revision_search">Search Sample Firmware Revision</label>
        </p-ifta-label>
        <p-button label="Add Sample Firmware Revision" icon="pi pi-plus" (click)="this.openCreateSampleFirmwareRevisionDialog()" isAdmin
                  [hidden]="false"></p-button>
    </div>
    <div class="border border-gray-300 dark:border-gray-700 p-2 dark:p-0 mb-5 rounded-sm">
        <p-table
                [value]="this.sampleFirmwareRevisions"
                [paginator]="true"
                [rows]="this.rows"
                [totalRecords]="this.totalRecords"
                [lazy]="true"
                [first]="this.currentPage * this.rows"
                [loading]="this.loading"
                [rowsPerPageOptions]="[5, 10, 20]"
                (onLazyLoad)="this.onPageChange($event)"
                paginatorDropdownAppendTo="body"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Firmware Revision</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Compatible Hardware Revisions</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-sampleFirmwareRevision>
                <tr>
                    <td>{{ sampleFirmwareRevision.releaseVersion }}</td>
                    <td>{{ sampleFirmwareRevision.description }}</td>
                    <td>{{ this.loadInstallationStatusDescription(sampleFirmwareRevision.installationStatus) }}</td>
                    <td>{{ resolveHardwareRevisions(sampleFirmwareRevision) }}</td>
                    <td>
                        <div class="flex justify-end">
                            <p-button icon="pi pi-download" text
                                      isAdmin
                                      [pTooltip]="sampleFirmwareRevision.fileName"
                                      tooltipPosition="left"
                                      (click)="this.downloadFirmwareFile(sampleFirmwareRevision.id)"></p-button>
                            <p-button icon="pi pi-pencil" text
                                      isAdmin
                                      pTooltip="Edit sample firmware revision"
                                      tooltipPosition="left"
                                      (click)="this.editSampleFirmwareRevision(sampleFirmwareRevision)"></p-button>

                            <p-button icon="pi pi-trash" text
                                      isAdmin
                                      pTooltip="{{ resolveIfSampleFirmwareRemovable(sampleFirmwareRevision) ? 'Deletion not allowed' : 'Delete sample firmware revision' }}"
                                      tooltipPosition="left"
                                      (click)="this.deleteSampleFirmwareRevision(sampleFirmwareRevision)"
                                      severity="danger"
                                      [disabled]="resolveIfSampleFirmwareRemovable(sampleFirmwareRevision)"></p-button>
                        </div>

                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<!-- Create Sample Firmware Revision Dialog -->
<app-create-sample-firmware-revision-dialog
        [(visible)]="this.displayCreateSampleFirmwareRevisionDialog"
        [allInstallationStatuses]="this.allInstallationStatuses"
        [allAvailableSampleHardwareRevisions]="this.allAvailableSampleHardwareRevisions"
        (sampleFirmwareRevisionCreated)="this.reloadSampleFirmwareRevisions()"
></app-create-sample-firmware-revision-dialog>

<!-- Update Sample Firmware Revision Dialog -->
<app-update-sample-firmware-revision-dialog
        [(visible)]="this.displayUpdateSampleFirmwareRevisionDialog"
        [sampleFirmwareRevision]="this.selectedSampleFirmwareRevision"
        [allInstallationStatuses]="this.allInstallationStatuses"
        [allAvailableSampleHardwareRevisions]="this.allAvailableSampleHardwareRevisions"
        (sampleFirmwareRevisionUpdated)="this.reloadSampleFirmwareRevisions()"
></app-update-sample-firmware-revision-dialog>

